
function removeProtocol(path: string): string {
  return path.replace(/http(s)?:/, '');
}

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
const getSizedImageUrl = (src: string, size: string): string => {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}

const getCroppedCenterURL = (img: string, size: string): string => {
  const unCroppedURL = getSizedImageUrl(img, size);
  const n = unCroppedURL.lastIndexOf('.');
  if(n < 1) return ''
  const imgURL = unCroppedURL.substring(0,n)+'_crop_center'+unCroppedURL.substring(n);
  return imgURL
}


export {getSizedImageUrl,getCroppedCenterURL}